<template>
  <div class="row">
    <div class="col-12">
      <div class="subpage">
        <h1 class="subpage__headline">
          Regulamin
        </h1>
        <div class="subpage__content">
          Regulamin strony reguluje zasady świadczenia usług drogą elektroniczną
          przez Fundację Greenpeace Polska, polegających na umożliwieniu
          Użytkownikom wsparcia kampanii Fundacji związanej z ochroną
          pszczół.<br /><br />
          Ilekroć w niniejszym Regulaminie jest mowa o:<br />
          &nbsp; &nbsp; &nbsp; &bull; Użytkowniku, należy przez to rozumieć
          każdą osobę korzystającą ze strony adoptujpszczole.pl,<br />
          &nbsp; &nbsp; &nbsp; &bull; Fundacji, należy przez to rozumieć
          Fundację Greenpeace Polska z siedzibą w Warszawie, ul. Altowa 4.<br />
          Strona internetowa adoptujpszczole.pl jest zarządzana przez
          Fundację.<br />
          Korzystanie ze strony jest nieodpłatne.<br />
          Za pośrednictwem strony można przez system PayU lub PayPal przekazać darowiznę na projekty związane z ochroną pszczół.
          Darowizna ma symboliczna formę „adopcji pszczół”.<br />
          Adoptować pszczołę może każda osoba fizyczna. Nie przyjmujemy darowizn od firm.
          Koszt adopcji jednej pszczoły wynosi 2 zł. Jeden użytkownik
          może przekazać darowiznę w wysokości 2 zł lub wielokrotności tej kwoty.<br />
          Użytkownik ma możliwość wyboru pomiędzy darowizną jednorazową a regularną, odnawianą co miesiąc.<br />
          Każdy Użytkownik korzystający z tej strony zobowiązany jest do
          przestrzegania niniejszego Regulaminu.<br />

          Fundacja zastrzega sobie prawo do jednostronnego decydowania o
          zawartości strony oraz podstron i modyfikowania jej, bez uprzedzania
          użytkowników o swoich zamiarach. Jakiekolwiek zmiany w regulaminie
          wchodzą w życie wraz z umieszczeniem ich na tej stronie. Ostateczna
          interpretacja i wykładnia postanowień Regulaminu należy do Fundacji
          Greenpeace Polska.<br />
          Przekazanie przez Użytkownika darowizny za pośrednictwem strony
          adoptujpszczole.pl jest równoznaczne z jego zgodą na postanowienia
          niniejszego Regulaminu.<br />
          Szanując prawa Użytkowników strony oraz respektując ustawę o ochronie
          danych osobowych, zobowiązujemy się do zachowania bezpieczeństwa i
          poufności pozyskanych danych osobowych, nieujawniania ich osobom
          trzecim, z zastrzeżeniem przewidzianych przez przepisy prawa
          okoliczności, gdy tego rodzaju ujawnienie jest obowiązkowe.<br />
          Na naszej stronie internetowej zbieramy następujące dane osobowe:<br />
          &nbsp; &nbsp; &nbsp; &bull; imię i nazwisko – podczas przekazania
          darowizny Użytkownik będzie proszony o podanie swojego imienia i
          nazwiska. Podanie imienia i nazwiska jest obowiązkowe przy
          przekazywaniu darowizny<br />
          &nbsp; &nbsp; &nbsp; &bull; adres e­mail – na adres e­mail zostanie
          wysłane potwierdzenie dokonania wpłaty i podziękowania (nie później
          jednak niż do końca listopada 2019). Za zgodą użytkownika będą
          wysyłane aktualności związane z działalnością Greenpeace Polska oraz
          informacje dotyczące akcji Adoptuj Pszczołę. Podanie adresu email jest
          obowiązkowe przy przekazywaniu darowizny.<br />
          &nbsp; &nbsp; &nbsp; &bull; adres IP – informacje wynikające z
          ogólnych zasad połączeń realizowanych w Internecie takie jak adres IP
          (oraz inne informacje zawarte w logach systemowych) wykorzystywane są
          przez administratora serwera w celach technicznych. Adresy IP mogą też
          być wykorzystywane w celach statystycznych – do zbierania ogólnych
          informacji demograficznych (np. o regionie, z którego następuje
          połączenie).<br />
          &nbsp; &nbsp; &nbsp; &bull; cookies – nasza strona wykorzystuje
          technologię Cookies w celu prowadzenia statystyk oglądalności.<br />
          &nbsp; &nbsp; &nbsp; &bull; numer telefonu<br />
          &nbsp; &nbsp; &nbsp; &bull; w przypadku płatności cyklicznych:
          ostatnie cztery cyfry karty płatniczej, termin ważności karty i
          miasto<br />
          Fundacja nie udostępnia żadnych danych osobom trzecim z wyjątkiem tych
          podmiotów, z którymi współpraca jest niezbędna do realizacji
          postanowień niniejszego regulaminu.<br />
          Zgodnie z postanowieniami ustawy z dnia 29 sierpnia 1997 r. o ochronie
          danych osobowych (Dz. U. z 2002 r. Nr 101, poz. 926 ze zm.) Użytkownik
          ma prawo poprawiania, uzupełniania, uaktualnienia, sprostowania oraz
          żądania usunięcia swoich danych osobowych. W tym celu użytkownik
          korzysta z zakładki kontakt, przesyłając wiadomość e–mail pod adres
          kontakt.pl@greenpeace.org lub listem poleconym na adres: Fundacja
          Greenpeace Polska ul. Altowa 4, 02­-386 Warszawa.<br />
          Wszelkie prawa do strony internetowej zastrzeżone są na rzecz
          Fundacji. Prawa autorskie do materiałów umieszczonych na stronie są
          własnością Fundacji Greenpeace Polska lub innych osób fizycznych bądź
          prawnych, o ile wyraźnie nie zaznaczono inaczej. Używanie tych
          materiałów do celów innych niż prywatnych jest dozwolone jedynie za
          pisemną zgodą Fundacji Greenpeace Polska.<br />
          Zabronione jest rozpowszechnianie, kopiowanie, publikowanie i
          wykorzystywanie komercyjne materiałów oraz wspomaganie lub
          umożliwianie osobom trzecim łamania powyższych zakazów.<br />
          Fundacja nie ponosi odpowiedzialności za wykorzystanie niezgodnie z
          prawem przez osoby trzecie treści i zasobów strony.<br />
          Fundacja Greenpeace Polska nie gwarantuje możliwości połączenia i
          zastrzega sobie prawo do wstrzymania udostępniania stron Serwisu ze
          względów technicznych.<br />
          Fundacja Greenpeace Polska nie ponosi odpowiedzialności za szkody
          powstałe wskutek korzystania z Serwisu w wyniku w szczególności:<br />
          &nbsp; &nbsp; &nbsp; &bull; działania sił wyższych,<br />
          &nbsp; &nbsp; &nbsp; &bull; niezabezpieczenia oprogramowania komputera
          Użytkownika podłączonego do sieci Internet, przed ingerencją osób
          trzecich,<br />
          &nbsp; &nbsp; &nbsp; &bull; braku ciągłości świadczenia usług Serwisu
          z powodów niezależnych od Fundacji Greenpeace Polska,<br />
          &nbsp; &nbsp; &nbsp; &bull; nieprawidłowego użytkowania Serwisu,<br />
          &nbsp; &nbsp; &nbsp; &bull; naruszenia postanowień niniejszego
          Regulaminu przez Użytkownika,<br />
          Wszelkie uwagi, pytania i opinie dotyczące funkcjonowania strony
          Użytkownicy mogą przesyłać na adres: kontakt.pl@greenpeace.org<br />
          Regulamin jest ogólnodostępny i obowiązuje z dniem jego obwieszczenia
          tj. z dniem 02.10.2019. Fundacja zastrzega sobie prawo do jego
          późniejszych zmian.<br />
          Prawem właściwym dla Regulaminu jest prawo Rzeczpospolitej Polskiej
          oraz Unii Europejskiej. Wszystkie kwestie, które nie zostały poruszone
          w niniejszym Regulaminie regulują odpowiednie przepisu Kodeksu
          cywilnego oraz ustawy o prawie autorskim i prawach pokrewnych.<br />
          Wszelkie spory powstałe w związku z korzystaniem z Serwisu będą
          rozstrzygane przez Sąd właściwy dla siedziby Fundacji Greenpeace
          Polska.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Rules",
  data() {
    return {
      title: "Rules page",
    };
  },
   mounted() {
    this.scrollToTop();
  },
  methods: {
    scrollToTop() {
      const width = window.innerWidth;
      let heightOfForm = document.getElementById("form__wrapper").scrollHeight;
      if (width > 768) {
        window.scroll({
          top: 0,
          left: 0,
        });
      } else {
        window.scroll({
          top: heightOfForm,
          left: 0,
        });
      }
    },
  },
};
</script>
